import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import PlateSizeEditor from '../editors/custom-editors/PlateSizeEditor';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

const PUT_PLATES_IN_INVENTORY_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.PUT_PLATES_IN_INVENTORY, 0).fields
);

export const PUT_PLATES_IN_INVENTORY_V0_UI_SCHEMA = {
  ...PUT_PLATES_IN_INVENTORY_BASE_UI_SCHEMA,
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['plateHeight', 'folderId', 'parentStorableId', 'studyIds', 'columnMapping'],
  plateHeight: {
    ...PUT_PLATES_IN_INVENTORY_BASE_UI_SCHEMA.plateHeight,
    displayName: 'Plate size',
    [CUSTOM_COMPONENT_KEY]: PlateSizeEditor,
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.PUT_PLATES_IN_INVENTORY, 0>;
